import CryptoJS from 'crypto-js/core'
import 'crypto-js/aes'
import 'crypto-js/mode-ecb'
import 'crypto-js/pad-pkcs7'

const AES_KEY = CryptoJS.enc.Utf8.parse('NfLSktjA4u4BiHgA')

export function encryptLoginField (value) {
  return CryptoJS.AES.encrypt(String(value), AES_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

export function createEncryptedLoginPayload (userName, password, loginRole) {
  return {
    loginType: 'wechat',
    userName: encryptLoginField(userName),
    password: encryptLoginField(password),
    wechat: '',
    loginRole: loginRole
  }
}



// WEBPACK FOOTER //
// ./src/utils/login-crypto.js